/* istanbul ignore file */
import { createSelector } from 'reselect'

export const userSelector = (state) => state && state.user

export const userDataSelector = createSelector(
    userSelector,
    (user) => user.data
)

export const isUserLoadedSelector = createSelector(
    userSelector,
    (user) => (user.data === null || (Object.keys(user.data).length > 0)),
)

export const userServicesSelector = createSelector(
    userDataSelector,
    (data) => data.groupedParkingBookingServices
)

export const userStatusSelector = createSelector(
    userSelector,
    (user) => user && user.status
)

export const userErrorSelector = createSelector(
    userStatusSelector,
    (status) => status && status.error
)

export const userIsLoadingSelector = createSelector(
    userStatusSelector,
    (status) => status && status.pending
)

export const userIsAvailableSelector = createSelector(
    userDataSelector,
    (user) => !!user
)

export const userMailSelector = createSelector(
    userDataSelector,
    (user) => user ? user.email : null
)

export const userIsLoggedInSelector = createSelector(
    userDataSelector,
    userIsAvailableSelector,
    (user, isAvailable) => isAvailable && user && !!user.id
)
